import React from 'react';
import PropTypes from 'prop-types';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Utils
import { calcDiversityText } from '../../../../utils';

// Styles
import styles from './jobTitleAndDiversity.module.scss';

const JobTitleAndDiversity = ({ job, title }) => (
  <h1 className={styles.header} data-testid="openingTitle">
    {title}{' '}
    {job.extra_info?.diversity && (
      <span className={styles.diversity}>
        {calcDiversityText(job.job_language?.mid)}
      </span>
    )}
  </h1>
);

JobTitleAndDiversity.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  title: PropTypes.string.isRequired,
};

export default JobTitleAndDiversity;
